import SidebarCollapseButton from '../primitives/SidebarCollapseButton';
import SidebarcContainer from '../primitives/SidebarContainer';
import SidebarFooter from '../primitives/SidebarFooter';
import SidebarHeader from '../primitives/SidebarHeader';
import SidebarLogo from '../primitives/SidebarLogo';
import { NavNode } from '../types';
import SidebarLinkItem from './SidebarLinkItem';
import SidebarNav from './SidebarNav';
import { paths } from '@/app/router/path';
import { useTranslation } from 'react-i18next';
import TutorialsIcon from '@/legacy/components/ui/Icons/TutorialsIcon';
import { Skeleton } from '@/shared/ui/skeleton';
import { ReactNode } from 'react';

type SideBarProps = {
	collapsed: boolean;
	toggleCollapse: () => void;
	navNodes: NavNode[];
	isLoading?: boolean;
	slot?: ReactNode;
	headerSlot?: ReactNode;
};

const NAV_SKELETON_COUNT = 6;

const Sidebar = ({
	collapsed,
	toggleCollapse,
	navNodes,
	isLoading,
	slot,
	headerSlot,
}: SideBarProps) => {
	const { t } = useTranslation();
	return (
		<SidebarcContainer collapsed={collapsed}>
			<SidebarHeader collapsed={collapsed}>
				<SidebarLogo collapsed={collapsed} />
				<SidebarCollapseButton
					collapsed={collapsed}
					onClick={toggleCollapse}
				/>
			</SidebarHeader>
			{headerSlot}
			<div className='flex-1 overflow-y-auto scrollbar-hidden -mx-4 px-4'>
				{isLoading ? (
					<div className='flex flex-col gap-2 py-2'>
						{Array.from({ length: NAV_SKELETON_COUNT }).map((_, i) => (
							<Skeleton
								key={i}
								height={40}
								borderRadius={8}
							/>
						))}
					</div>
				) : (
					<SidebarNav
						navNodes={navNodes}
						size={collapsed ? 'collapsed' : 'default'}
						onExpandSidebar={collapsed ? toggleCollapse : undefined}
					/>
				)}
			</div>
			{slot}
			<SidebarFooter>
				<ul>
					<SidebarLinkItem
						text={t('nav.tutorials')}
						size={collapsed ? 'collapsed' : 'default'}
						icon={<TutorialsIcon />}
						variant='highlighted'
						to={paths.support.base()}
						useIndicator={false}
					/>
				</ul>
			</SidebarFooter>
		</SidebarcContainer>
	);
};

export default Sidebar;
